import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as actions from '../../actions/answer-action';
import { bindActionCreators } from 'redux';
import { Table } from 'react-bootstrap';
import { useGetTicketAnswers } from '../../hooks/services/sTicket/useOfTicketAnswer';
import { connect, useDispatch  } from 'react-redux';
import { Icon } from '@fluentui/react';

const TicketAnswer =  ({ actionsAnswerConnect, ticket_id, handleSelectedTicketAnswer }) => {

    const [ticketAnswers, setTicketAnswers] = useState(null);

    useGetTicketAnswers(ticketAnswers, setTicketAnswers, ticket_id);
  
    useEffect(() => {            
        if(ticketAnswers)
        {
            actionsAnswerConnect.setAnswers(ticketAnswers);
        }
        
  }, [actionsAnswerConnect, ticketAnswers]);

  

    const allTableItems = ticketAnswers?.map(tableItem => (
        <tr key={tableItem.id}>
            <td>{tableItem.subject}</td><td>{tableItem.creation_date}</td>
            <td>
            <span>{tableItem.has_docs && <Icon iconName='Attach' style={{paddingBottom: "10px", fontSize: "16px", fontFamily: "FabricMDL2Icons"}} />}</span>
            </td>
            <td>
            <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => handleSelectedTicketAnswer(tableItem.id)}
                        >       Documents
                    </button>
            </td>
        </tr>
    ));
    
    return (
        <Table>
            <tbody>
                {allTableItems}
            </tbody>
        </Table>
    );
    
  
};


TicketAnswer.propTypes = {
    ticket_id: PropTypes.number.isRequired,    
    actionsAnswerConnect: PropTypes.shape({
      addAnswerItem: PropTypes.func,
      fetchAnswerItems: PropTypes.func,
      deleteAnswerItem: PropTypes.func,
      saveAnswerItem: PropTypes.func,      
    }),
  };

const mapStateToProps = state => ({
    tableAnswer: state.answers.tableAnswer,
  });
  
  const mapDispatchToProps = dispatch => ({
    actionsAnswerConnect: bindActionCreators(actions, dispatch),
  });


export default connect(mapStateToProps, mapDispatchToProps)(TicketAnswer);
